import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.search";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from '@/mixins/packageTableMixins';
import samplingCustom from './components/samplingCustom';
import refreshCustom from './components/refreshCustom';
import moreCustom from './components/moreCustom';
import logoImg1 from '@/assets/images/battery1.png';
import logoImg2 from '@/assets/images/battery2.png';
import logoImg3 from '@/assets/images/battery3.png';
import logoImg4 from '@/assets/images/battery4.png';
import { ChartPie, ChartItemBar, ChartLineStackMul2 } from '_c/charts';
import echarts from 'echarts';
import { iotdatalastget as _iotdatalastget, get_rl_trends as _get_rl_trends, web_issue_order, get_firmware_info, upup_firmware, config_caiyang_pinglv, config_nibianqi } from '@/api/jingxiaoshang';
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data: function data() {
    var _this2 = this;

    return {
      maxinfo: 0,
      maxinfo2: 0,
      alertTotalList: 0,
      alertTimeList: [],
      alertDataList: [],
      alertTimeList2: [],
      alertDataList2: [],
      is_day: 0,
      is_month: 0,
      is_year: 0,
      button1: "new_button_check",
      button2: "new_button",
      button3: "new_button",
      button4: "new_button",
      legendData3: [],
      xAxisData3: [],
      seriesData3: [],
      rongliang_trends: [],
      check_did: "",
      firmware_list: [],
      spinShow: true,
      show_caiyang: false,
      dui: {},
      bingji: [],
      imgLogo1: logoImg1,
      imgLogo2: logoImg2,
      imgLogo3: logoImg3,
      imgLogo4: logoImg4,
      can_lineData: [],
      chuan_lineData: [],
      wang_lineData: [],
      dingshi: null,
      shuaxin: 5,
      caiyang_pinglv: 0,
      uploadLoading: false,
      details_data: [],
      did: "",
      buttonSize2: "BMU1",
      buttonSize1: "BCU1",
      columns11: [{
        title: '',
        //    slot: 'name',
        key: 'name'
      }, {
        title: '1',
        key: 'a1'
      }, {
        title: '2',
        key: 'a2'
      }, {
        title: '3',
        key: 'a3'
      }, {
        title: '4',
        key: 'a4'
      }, {
        title: '5',
        key: 'a5'
      }, {
        title: '6',
        key: 'a6'
      }, {
        title: '7',
        key: 'a7'
      }, {
        title: '8',
        key: 'a8'
      }],
      data11: [{
        name: '电压',
        a1: "1.1V",
        a2: '1.1V',
        a3: '1.1V',
        a4: '1.1V',
        a5: '1.1V',
        a6: '1.1V',
        a7: '1.1V',
        a8: '1.1V'
      }],
      data12: [{
        name: '温度',
        a1: "1.1V",
        a2: '1.1V',
        a3: '1.1V',
        a4: '1.1V',
        a5: '1.1V',
        a6: '1.1V',
        a7: '1.1V',
        a8: '1.1V'
      }],
      data13: [{
        name: '端子温度',
        a1: "1.1V",
        a2: '1.1V',
        a3: '1.1V',
        a4: '1.1V',
        a5: '1.1V',
        a6: '1.1V',
        a7: '1.1V',
        a8: '1.1V'
      }],
      devicename: "aaaaaaaa",
      columns4: [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: '参数名',
        key: 'param_name'
      }, {
        title: '当前值',
        key: 'now_value'
      }, {
        title: '设置值',
        key: 'config_value',
        slot: 'action'
      }, {
        title: '操作',
        key: 'action',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          return h('div', [h('Button', {
            props: {
              type: 'primary',
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: function click() {
                _this2.show(params.index);
              }
            }
          }, '发送')]);
        }
      }],
      data1: [{
        id: 1,
        param_name: '单体高压1_保护值',
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: '单体高压1_保护延时',
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: '单体高压1_保护恢复值',
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: '单体高压1_保护恢复延时',
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: '单体高压2_保护值',
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: '单体高压2_保护延时',
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: '单体高压2_保护恢复值',
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: '单体高压2_保护恢复延时',
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: '单体高压3_保护值',
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: '单体高压3_保护延时',
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: '单体高压3_保护恢复值',
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: '单体高压3_保护恢复延时',
        now_value: 18,
        config_value: 22
      }],
      show1_1: true,
      show1_2: true,
      show1_3: true,
      is_update: 100,
      tabData: [{
        name: "单体高压",
        value: 1
      }, {
        name: "单体低压",
        value: 2
      }, {
        name: "总体高压",
        value: 3
      }, {
        name: "总体低压",
        value: 4
      }, {
        name: "充电过流",
        value: 5
      }, {
        name: "放电过流",
        value: 6
      }, {
        name: "充电高温",
        value: 7
      }, {
        name: "充电低温",
        value: 8
      }, {
        name: "放电高温",
        value: 9
      }, {
        name: "放电低温",
        value: 10
      }, {
        name: "充电温差",
        value: 11
      }, {
        name: "放电温差",
        value: 12
      }, {
        name: "电芯温升",
        value: 13
      }, {
        name: "SOC高",
        value: 14
      }, {
        name: "SOC低",
        value: 15
      }, {
        name: "正极绝缘漏电",
        value: 16
      }, {
        name: "负极绝缘漏电",
        value: 17
      }, {
        name: "环境高温",
        value: 18
      }, {
        name: "环境低温",
        value: 19
      }, {
        name: "充电压差",
        value: 20
      }, {
        name: "放电压差",
        value: 21
      }, {
        name: "端子高温",
        value: 22
      }, {
        name: "风扇控制",
        value: 23
      }, {
        name: "电芯故障",
        value: 24
      }, {
        name: "满充参数",
        value: 25
      }, {
        name: "均衡参数",
        value: 26
      }, {
        name: "容量",
        value: 27
      }, {
        name: "短路保护",
        value: 28
      }, {
        name: "掉电开关",
        value: 29
      }, {
        name: "继电器控制",
        value: 30
      }, {
        name: "基础控制",
        value: 31
      }, {
        name: "保护功能",
        value: 32
      }],
      form_filter: {
        tabname: null
      },
      form_filter2: {
        search_type: 1,
        search_date: null
      },
      formModel: {
        dcac_canid: null,
        dcac_comid: null,
        dcac_netid: null
      },
      tab_check: "",
      //共用的查询与重置
      topButtonList: [{
        name: '查询',
        type: 'primary',
        method: this.search
      }, {
        name: '重置',
        type: 'error',
        method: this.reset
      }]
    };
  },
  components: {
    ChartPie: ChartPie,
    ChartItemBar: ChartItemBar,
    ChartLineStackMul2: ChartLineStackMul2
  },
  methods: {
    dateChange: function dateChange(val) {
      //alert(val)
      if (val) {
        this.$set(this.form_filter2, "search_date", val);
        this.get_rl_trends();
      }
    },
    clicksearchtype: function clicksearchtype(index) {
      if (index == 1) {
        this.button1 = "new_button_check";
        this.button2 = "new_button";
        this.button3 = "new_button";
        this.button4 = "new_button";
        this.is_day = 0;
        this.is_month = 0;
        this.is_year = 0;
        this.form_filter2.search_type = 1; // this.$set(this.form_filter2, "search_type", 1);
      }

      if (index == 2) {
        this.button1 = "new_button";
        this.button2 = "new_button_check";
        this.button3 = "new_button";
        this.button4 = "new_button";
        this.is_day = 1;
        this.is_month = 0;
        this.is_year = 0;
        this.form_filter2.search_type = 2; //this.$set(this.form_filter2, "search_type", 2)
      }

      if (index == 3) {
        this.button1 = "new_button";
        this.button2 = "new_button";
        this.button3 = "new_button_check";
        this.button4 = "new_button";
        this.is_day = 0;
        this.is_month = 1;
        this.is_year = 0;
        this.form_filter2.search_type = 3; //this.$set(this.form_filter2, "search_type", 3)
      }

      if (index == 4) {
        this.button1 = "new_button";
        this.button2 = "new_button";
        this.button3 = "new_button";
        this.button4 = "new_button_check";
        this.is_day = 0;
        this.is_month = 0;
        this.is_year = 1;
        this.form_filter2.search_type = 4; //this.$set(this.form_filter2, "search_type", 4)
      }

      this.get_rl_trends();
    },
    web_shuaxin: function web_shuaxin() {
      web_issue_order({
        "did": this.did,
        "tab_check": this.tab_check
      }).then(function (res) {});
    },
    change_tab2: function change_tab2(name) {
      this.tab_check = name; //alert(this.tab_check)

      if (this.tab_check == "固件升级") {
        this.check_new();
      } else if (this.tab_check == "PACK详情数据" || this.tab_check == "汇总数据") {
        //alert(123)
        this.get_rl_trends();
      }
    },
    check_firmware: function check_firmware() {},
    change_tab: function change_tab(name) {
      this.details_data = []; // this.caiyang_pinglv = [];
      // this.dui = [];
      // this.bingji = [];

      var didstr = name.split(" "); //alert(name);

      this.check_did = didstr[0];
      this.iotdatalastget(didstr[0]);
    },
    nibianqi_change: function nibianqi_change(value, type) {
      var _this3 = this;

      //   console.log(event)
      //  return
      config_nibianqi({
        value: value,
        type: type,
        did: this.did
      }).then(function (res) {
        var msg = res.errorMsg;

        if (res.result === 0) {
          _this3.$Message.success(msg);
        } else {
          _this3.$Message.error(msg);
        }
      });
    },
    //查看详情
    iotdatalastget: function iotdatalastget(did) {
      var _this4 = this;

      // alert(1);
      // return;
      if (did) {
        this.did = did;
      } else {
        if (this.check_did) {
          this.did = this.check_did;
        } else {
          var q = this.$route.query;
          this.did = q.did;
        }
      }

      var bj_arr = [];

      for (var bj in this.bingji) {
        var bj_str = this.bingji[bj].split(" ");
        bj_arr.push(bj_str[0]);
      }

      _iotdatalastget({
        "did": this.did,
        "bingji": bj_arr,
        "tab_check": this.tab_check
      }).then(function (res) {
        _this4.tableLoading = false;
        _this4.tableDataList = [];

        if (res.result === 0) {
          var length = Object.keys(res.body).length;

          if (length == 1) {
            _this4.check_new();
          } // console.log(res)
          // return 


          _this4.show_caiyang = true;
          _this4.details_data = res.body;
          _this4.caiyang_pinglv = res.other.caiyang_pinglv;
          _this4.dui = res.other.dui;
          _this4.bingji = res.other.bingji; //this.rongliang_trends=res.other.rongliang_trends
          //循环找到逆变器

          _this4.alertTimeList.splice(0);

          _this4.alertDataList.splice(0);

          _this4.alertTimeList2.splice(0);

          _this4.alertDataList2.splice(0); //趋势数据


          var tem1 = [];
          var x_axis = 0; //  alert(res.body['单体数据'][""].cell_voltage[2]);

          for (var i = 0; i < res.body['单体数据'][""].cell_voltage.length; i++) {
            var list = res.body['单体数据'][""].cell_voltage[i];
            tem1.push(list);
            _this4.maxinfo = res.body['单体数据'][""].ghll.dianya_high + 2000;
            x_axis = i + 1;

            _this4.alertTimeList.push(x_axis);

            _this4.alertDataList.push({
              name: "电芯电压（mv）",
              data: tem1,
              type: 'line',
              lineStyle: {
                width: 2
              },
              smooth: true,
              markLine: {
                symbol: 'none',
                // 去掉辅助线首尾圆点和箭头
                lineStyle: {
                  color: '#999',
                  type: 'dashed' // 实线

                },
                data: [{
                  yAxis: res.body['单体数据'][""].ghll.dianya_high,
                  // 纵坐标的值，决定横向辅助线在y轴的位置
                  label: {
                    formatter: '最高限制'
                  }
                }, {
                  yAxis: res.body['单体数据'][""].ghll.dianya_low,
                  // 纵坐标的值，决定横向辅助线在y轴的位置
                  label: {
                    formatter: '最低限制'
                  }
                }]
              }
            });
          } //趋势数据


          var tem2 = [];
          var x_axis2 = 0; //  alert(res.body['单体数据'][""].cell_voltage[2]);

          for (var _i = 0; _i < res.body['单体数据'][""].cell_temperature.length; _i++) {
            var list2 = res.body['单体数据'][""].cell_temperature[_i];
            tem2.push(list2 / 10);
            _this4.maxinfo2 = Math.max.apply(Math, tem2) + 20;
            x_axis2 = _i + 1;

            _this4.alertTimeList2.push(x_axis2);

            _this4.alertDataList2.push({
              name: "电芯温度（℃）",
              data: tem2,
              type: 'line',
              lineStyle: {
                width: 2
              },
              smooth: true //       markLine: {
              //   symbol: 'none', // 去掉辅助线首尾圆点和箭头
              // 	lineStyle:{
              // 		color: '#999', 
              // 		type: 'dashed', // 实线
              // 	},
              //   data: [
              //     {
              //       yAxis: 25, // 纵坐标的值，决定横向辅助线在y轴的位置
              // 			label:{
              // 				formatter: '最高限制',
              // 			},
              //     },
              //     {
              //       yAxis: 20, // 纵坐标的值，决定横向辅助线在y轴的位置
              // 			label:{
              // 				formatter: '最低限制',
              // 			},
              //     },
              //   ]
              // }

            });
          }

          if (res.body['设备信息']) {
            for (var _i2 in res.body['设备信息'][""]) {
              var _list = res.body['设备信息'][""][_i2]; //console.log("aasdf"+list['name_cn']) 

              if (_list.type == "can_line") {
                //console.log(list['old'])
                _this4.can_lineData = _list['old'];
              } else if (_list.type == "chuan_line") {
                _this4.chuan_lineData = _list['old'];
              } else if (_list.type == "wang_line") {
                _this4.wang_lineData = _list['old'];
              }

              if (_list.name_en == "dcac_canid") {
                //console.log("list['old']"+list['old'])
                // for (let ii in res.body['设备信息'][""]) { 
                // }
                _this4.formModel.dcac_canid = _list['old'];
              } else if (_list.name_en == "dcac_comid") {
                _this4.formModel.dcac_comid = _list['old'];
              } else if (_list.name_en == "dcac_netid") {
                _this4.formModel.dcac_netid = _list['old'];
              }
            }
          }

          _this4.spinShow = false; //设置发送刷新命令

          console.log(_this4.shuaxin); //(alert(1), 5000)  

          setTimeout(function () {
            _this4.web_shuaxin();
          }, (_this4.shuaxin - 4) * 1000); //this.$nextTick(() => { 
          //   setTimeout(alert( (this.shuaxin - 2) * 1000), (this.shuaxin - 2) * 1000)
          // }) //this.web_shuaxin()
          // this.can_lineData = 
        } else {
          _this4.tableDataList = [];
          _this4.getPageTotal = 0;

          _this4.$Message.error(res.errorMsg);
        }
      });
    },

    /**
    * 升级固件
    */
    uploadFirmware: function uploadFirmware(key) {
      var did = this.firmware_list[key].did;
      var pint0 = this.firmware_list[key].chan_id;
      var pint1 = this.firmware_list[key].firmware_size;
      var pstr0 = this.firmware_list[key].firmware_md5;
      var pstr1 = this.firmware_list[key].firmware_ver;
      var pbs = this.firmware_list[key].firmware_url;
      var vm = this;
      var config = {
        title: "升级",
        loading: true,
        content: "您确定要升级通道" + pint0 + "的固件吗？",
        onOk: function onOk() {
          var _this = this;

          upup_firmware({
            did: did,
            'pint': [pint0, pint1],
            'pstr': [pstr0, pstr1],
            'pbs': pbs
          }).then(function (res) {
            if (res.result === 0) {
              _this.$Message.success(res.errorMsg);

              vm.$Modal.remove(); // this.getFirmwareInfo()
            } else {
              _this.$Message.error(res.errorMsg);
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    get_rl_trends: function get_rl_trends() {
      var _this5 = this;

      // alert(this.form_filter2.search_type);
      // return;
      _get_rl_trends({
        "did": this.did,
        "search_type": this.form_filter2.search_type,
        "search_date": this.form_filter2.search_date
      }).then(function (res) {
        _this5.tableLoading = false;
        _this5.rongliang_trends = [];

        if (res.result === 0) {
          //this.details_data = res.body;
          // if (res.body.firmware == "") {
          //   this.$Message.error("暂无可更新固件");
          // }
          if (res.body.rongliang_trends && res.body.rongliang_trends.length > 0) {
            _this5.rongliang_trends = res.body.rongliang_trends;

            _this5.xAxisData3.splice(0);

            _this5.legendData3.splice(0);

            _this5.seriesData3.splice(0);

            var xAxis3 = [];
            var xAxis3_1 = [];

            if (_this5.rongliang_trends && _this5.rongliang_trends.length > 0) {
              for (var j in _this5.rongliang_trends) {
                _this5.xAxisData3.push(_this5.rongliang_trends[j].x_axis);

                xAxis3.push(_this5.rongliang_trends[j].total_chongdian);
                xAxis3_1.push(_this5.rongliang_trends[j].total_fangdian);
              }
            }

            _this5.seriesData3.push({
              name: '累计充电容量',
              type: 'bar',
              tooltip: {
                valueFormatter: function valueFormatter(value) {
                  return value + ' mAh';
                }
              },
              data: xAxis3
            }, {
              name: '累计放电容量',
              type: 'bar',
              tooltip: {
                valueFormatter: function valueFormatter(value) {
                  return value + ' mAh';
                }
              },
              data: xAxis3_1
            });
          } else {//this.is_update=0
            //this.$Message.error("暂无可升级的固件")
          }
        } else {
          _this5.tableDataList = [];
          _this5.getPageTotal = 0;

          _this5.$Message.error(res.errorMsg);
        }
      });
    },
    //检测新的固件版本
    check_new: function check_new() {
      var _this6 = this;

      //alert(123)
      //get_firmware_info
      // console.log("aaa",this.did)
      //获取设备信息
      get_firmware_info({
        "did": this.did
      }).then(function (res) {
        _this6.tableLoading = false;
        _this6.tableDataList = [];

        if (res.result === 0) {
          //this.details_data = res.body;
          // if (res.body.firmware == "") {
          //   this.$Message.error("暂无可更新固件");
          // }
          if (res.body.firmware && res.body.firmware.length > 0) {
            _this6.is_update = res.body.firmware[0].is_update;

            if (_this6.is_update === 0) {//  this.$Message.info("已经是最新版本")
            } else {//  this.$Message.success("检测出可升级的固件")
              }

            _this6.firmware_list = res.body.firmware;
          } else {
            _this6.is_update = 0;

            _this6.$Message.error("暂无可升级的固件");
          }
        } else {
          _this6.tableDataList = [];
          _this6.getPageTotal = 0;

          _this6.$Message.error(res.errorMsg);
        }
      });
    },
    init: function init() {
      this.spinShow = true;
      this.shuaxin = localStorage.getItem('shuaxin') || 5; //获取设备信息

      this.iotdatalastget(); //setTimeout( this.web_shuaxin(), 2000 )
    },
    refresh: function refresh() {
      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h('div', [h('div', {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, [h('h3', {
            style: {
              width: '100%',
              paddingBottom: '5px'
            }
          }, '刷新频率'), h('icon', {
            props: {
              type: 'md-close',
              size: '16'
            },
            style: {
              cursor: 'pointer'
            },
            on: {
              'click': function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h('Divider', {
            style: {
              margin: '8px 0'
            }
          }), h(refreshCustom, {
            ref: 'refreshCustom',
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false,
              shuaxin: localStorage.getItem('shuaxin') || 5,
              parent_code: '0',
              parent_name: '无'
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.refreshCustom;
          obj.checkForm().then(function (res) {
            if (res) {
              // console.log(obj.formModel)
              vm.shuaxin = obj.formModel.refresh_value;
              vm.$Message.success(vm.$t('设置成功'));
              vm.$Modal.remove();
              clearInterval(vm.dingshi);
              vm.dingshi = setInterval(vm.iotdatalastget, vm.shuaxin * 1000);
              localStorage.setItem('shuaxin', vm.shuaxin); //     vm.init() 
            }
          }); // let _this = this;
          // let obj = this.$refs.refreshCustom;
          // obj.checkForm().then(res => { 
          // if (res) { 
          //   area_add({...obj.formModel}).then(res => {
          //   let msg=res.errorMsg;
          //   if (res.result === 0) {
          //     let msg=res.errorMsg;
          //     vm.$Message.success(msg);
          //     vm.$Modal.remove(); 
          //     vm.init()
          //   } else {
          //   vm.$Message.error(msg);
          //     _this.buttonLoading = false;
          //   }
          // });
          // } else {
          //     _this.buttonLoading = false;
          // }
          //  });
        }
      };
      this.$Modal.confirm(config);
    },
    more: function more(title, morevalue) {
      var vm = this;
      var config = {
        loading: true,
        width: 500,
        okText: "关闭",
        render: function render(h) {
          return h('div', [h('div', {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, [h('h3', {
            style: {
              width: '100%',
              paddingBottom: '5px'
            }
          }, title), h('icon', {
            props: {
              type: 'md-close',
              size: '16'
            },
            style: {
              cursor: 'pointer'
            },
            on: {
              'click': function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h('Divider', {
            style: {
              margin: '8px 0'
            }
          }), h(moreCustom, {
            ref: 'moreCustom',
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: true,
              parent_code: '0',
              parent_name: '无',
              morevalue: morevalue
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.moreCustom;
          obj.checkForm().then(function (res) {
            if (res) {
              // vm.$Message.success("");
              vm.$Modal.remove(); //vm.init()
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.success(config);
    },
    sampling: function sampling() {
      var _this7 = this;

      //   alert(sampling)
      //  return;
      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h('div', [h('div', {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, [h('h3', {
            style: {
              width: '100%',
              paddingBottom: '5px'
            }
          }, '采样频率设置'), h('icon', {
            props: {
              type: 'md-close',
              size: '16'
            },
            style: {
              cursor: 'pointer'
            },
            on: {
              'click': function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h('Divider', {
            style: {
              margin: '8px 0'
            }
          }), h(samplingCustom, {
            ref: 'samplingCustom',
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false,
              parent_code: '0',
              parent_name: '无',
              did: vm.did,
              caiyang_pinglv: _this7.caiyang_pinglv
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.samplingCustom;
          obj.checkForm().then(function (res) {
            if (res) {
              //this.caiyang_pinglv=obj.formModel.sampling_value
              config_caiyang_pinglv(_objectSpread({}, obj.formModel)).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  //console.log('aaa',obj.formModel.sampling_value)
                  var _msg = res.errorMsg;
                  vm.$Message.success(_msg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    handleSelectAll: function handleSelectAll(status) {
      this.$refs.selection.selectAll(status);
    },
    reset: function reset() {
      this.form_filter = {
        tabname: null
      };
      var str = "";

      for (var i = 1; i <= 32; i++) {
        str = "" + "show1_" + i;
        this[str] = true;
      } // this.search()

    },
    search: function search() {
      var str = "";

      for (var i = 1; i <= 32; i++) {
        str = "" + "show1_" + i;
        this[str] = false;
      }

      var xuhao = 0;

      for (var _i3 in this.form_filter.tabname) {
        xuhao = parseInt(_i3) + 1;
        str = "" + "show1_" + xuhao;
        console.log(str);
        this[str] = true;
      }
    }
  },
  mounted: function mounted() {
    this.init();
    this.dingshi = setInterval(this.iotdatalastget, this.shuaxin * 1000); // this.dingshi_shuaxin=setInterval(this.web_issue_order, this.shuaxin*1000);
  },
  destroyed: function destroyed() {
    //alert(123)  
    clearInterval(this.dingshi);
  },
  watch: {
    $route: function $route(to, from) {
      clearInterval(this.dingshi);
    }
  }
};